// extracted by mini-css-extract-plugin
export var active = "TabContent-module--active--395d3";
export var container = "TabContent-module--container--b4ce5";
export var content = "TabContent-module--content--34fbe";
export var tab = "TabContent-module--tab--01fbc";
export var tabs = "TabContent-module--tabs--d1833";